import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  data: string;
  status: ReduxStateType;
}

const initialState: InitialState = {
  data: "",
  status: ReduxStateType.INIT,
};

const formCommentSlice = createSlice({
  name: "formComment",
  initialState,
  reducers: {
    updateComment: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    resetComment: () => {
      return { ...initialState };
    },
  },
});

export const { updateComment, resetComment } = formCommentSlice.actions;

export default formCommentSlice.reducer;
